// 组件对象，大写
import dataTable from './dataTable.vue'
export default dataTable
